/**
 * Created by Administrador on 20/11/2017.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', 'CONFIG'];

    function stateConfig($stateProvider, CONFIG) {
        $stateProvider
            .state('notifications', {
                parent: 'app',
                url: '/notifications',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configCargo/notification/notifications.html',
                        controller: 'notificationCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['notification']);
                            }],
                            notifications: ['notificationService', function (notificationService) {
                                return notificationService.getNotificationList();
                            }]
                        }
                    }
                }
            })
            .state('notificationNew', {
                parent: 'app',
                url: '/notification/new',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configCargo/notification/newNotification.html',
                        controller: 'newEditNotificationCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabAdminClassifications('notifications')
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['notification']);
                            }],
                            action: [function () {
                                return "new";
                            }],
                            notification: [function () {
                                return null;
                            }]
                        }
                    }
                }
            })
            .state('notificationEdit', {
                parent: 'app',
                url: '/notification/:id/edit',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                views: {
                    'main@': {
                        templateUrl: 'app/admin/configCargo/notification/editNotification.html',
                        controller: 'newEditNotificationCtrl',
                        controllerAs: 'vm',
                        resolve: {
                            tabs: ['tabService', function (tabService) {
                                return tabService.getTabAdminClassifications('notifications')
                            }],
                            notification: ['notificationService', '$stateParams', function (notificationService, $stateParams) {
                                return notificationService.getNotification($stateParams.id)
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['notification']);
                            }],
                            action: [function () {
                                return "edit";
                            }]
                        }
                    }
                }
            })
            .state('notificationDelete', {
                parent: 'notifications',
                url: '/notification/:id/delete',
                data: {
                    authorities: CONFIG.AUTHORITIES_ALL
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/configCargo/notification/deleteNotification.html',
                        controller: 'deleteNotificationCtrl',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            notification: ['notificationService', function (notificationService) {
                                return notificationService.getNotification($stateParams.id)
                            }],
                            translatePartialLoader: ['translationHandler', function (translationHandler) {
                                return translationHandler.translateRefresh(['notification']);
                            }]
                        }
                    }).result.then(function () {
                        $state.go('notifications', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }
})();
